export default __webpack_public_path__ + "static/media/upArrow.db43e5cd.svg";